export const removeEmptyPathSegments = (pathSegments: string[]) =>
  pathSegments.filter((pathSegment) => pathSegment.length > 0);
